import Flex from '@Components/Bases/Flex';
import UserProfileButton from '@Components/UserButton/UserButton';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useProfile } from 'src/Constant/UserProfileContext/UserProfileProvider';
import CVUPLogo from './CVUPLogo';

export const navbarHeight = 51;
const Navbar = () => {
  const { user } = useProfile();

  return (
    <AppBar
      color="inherit"
      sx={{
        boxShadow: '2px 2px 5px 0px rgba(0,0,0,0.1)',
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          overflow: 'hidden',
          borderBottom: 3,
          borderColor: 'primary.main',
        }}
      >
        <Flex alignItems="center" gap={1} height={navbarHeight}>
          <CVUPLogo />
          <Typography variant="subtitle2">{`${
            user?.N_COMPANY_THAI || ''
          }`}</Typography>
        </Flex>
        <UserProfileButton
          name={user?.N_NAME}
          surname={user?.N_SURNAME}
          role={user?.N_LOGIN}
        />
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
